import {
  type KeyOfType,
  getValueFromKeyOfType,
} from '../../../types/KeyOfType';
import { createDefaultFilter } from '../../filters/createDefaultFilter';
import type { TableColumnBase } from '../TableColumnBase';
import {
  type TableDataColumnConfig,
  pickTableColumnConfig,
} from '../TableColumnConfig';
import { formatValueToCsvString } from './helpers/formatValueToCsvString';

export type TableColumnFormatObject<TRow, TObject> = {
  type: 'object';
  field: KeyOfType<TRow, TObject | null>;
  toWebString: (value: TObject | null) => string;
};

export const createObjectColumn: {
  <TRow, TObject>(
    config: TableDataColumnConfig<TRow, TObject> & {
      array?: false;
      toWebString: (value: TObject) => string;
    },
  ): TableColumnBase<TRow, TableColumnFormatObject<TRow, TObject>>;
  <TRow, TObject>(
    config: TableDataColumnConfig<TRow, TObject[]> & {
      array: true;
      toWebString: (value: TObject) => string;
    },
  ): TableColumnBase<TRow, TableColumnFormatObject<TRow, TObject>>;
} = <TRow, TObject>(
  config: TableDataColumnConfig<TRow, TObject | null> & {
    toWebString: (value: TObject | null) => string;
  },
): TableColumnBase<TRow, TableColumnFormatObject<TRow, TObject>> => ({
  ...pickTableColumnConfig(config),
  format: {
    type: 'object',
    field: config.key,
    toWebString: config.toWebString,
  },
  csvStringDependencies: [config.key],
  webDependencies: [config.key],
  toCsvString: (row) => {
    const val = getValueFromKeyOfType(row, config.key);

    return val
      ? formatValueToCsvString(val as TObject | TObject[], config.toWebString)
      : '';
  },
  filter: createDefaultFilter(config.filter, undefined),
});
